import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import OrdiniPage from "@/pages/OrdiniPage";
import DeleghePage from "@/pages/DeleghePage";
import GTLPage from "@/pages/GTLPage";
import GTLDetailPage from "@/pages/GTLDetailPage";
import ExportPage from "@/pages/ExportPage";
import ImpostazioniPage from "@/pages/ImpostazioniPage";
import NominaDelegatiPage from "@/pages/NominaDelegatiPage";
import SegnalazioniGTLPage from "@/pages/SegnalazioniGTLPage";
import CambiaPasswordPage from "@/pages/CambiaPasswordPage";
import PublicDelegatiPage from "@/pages/PublicDelegatiPage";
import PublicGTLPage from "@/pages/PublicGTLPage";
import PublicGTLDetailPage from "@/pages/PublicGTLDetailPage";
import Layout from "@/components/Layout";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="spinner" data-testid="loading-spinner"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes - no auth required */}
          <Route path="/delegati-pubblico" element={<PublicDelegatiPage />} />
          <Route path="/gtl-pubblico" element={<PublicGTLPage />} />
          <Route path="/gtl-pubblico/:id" element={<PublicGTLDetailPage />} />
          
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="ordini" element={<OrdiniPage />} />
            <Route path="deleghe" element={<DeleghePage />} />
            <Route path="gtl" element={<GTLPage />} />
            <Route path="gtl/:id" element={<GTLDetailPage />} />
            <Route path="export" element={<ExportPage />} />
            <Route path="impostazioni" element={<ImpostazioniPage />} />
            <Route path="nomina-delegati" element={<NominaDelegatiPage />} />
            <Route path="segnalazioni-gtl" element={<SegnalazioniGTLPage />} />
            <Route path="cambia-password" element={<CambiaPasswordPage />} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
